import * as React from "react";

import { VictoryBar } from "victory-bar";
import { VictoryLabel } from "victory-core";
import { VictoryLine } from "victory-line";
import { VictoryScatter } from "victory-scatter";
import { measureColors as colorMapping } from "../../../services/measureColors";
import {
    DataForChart,
    defaultChartLabelStyle as defaultLabelStyle,
    getFontSize,
    chartWidthBreakpoints as widthBreakpoints
} from "./service";

export const renderBar = ({
    measure,
    chartWidth,
    chartData
}: {
    measure: string;
    chartWidth: number;
    chartData: { [key: string]: DataForChart[] };
}) => {
    let data = chartData[measure].slice(1, -1);
    let color = colorMapping[measure];
    let labelColor = colorMapping[measure + "Label"] || color;
    return (
        <VictoryBar
            key={measure}
            data={data}
            style={{ data: { stroke: color, strokeWidth: 4, fill: color } }}
            name={`${measure}-bar`}
            labelComponent={
                <VictoryLabel
                    style={{
                        fill: labelColor,
                        ...defaultLabelStyle,
                        fontSize: getFontSize(chartWidth)
                    }}
                    dy={5}
                    renderInPortal
                />
            }
        />
    );
};

export const renderLine = ({
    measure,
    chartWidth,
    chartData
}: {
    measure: string;
    chartWidth: number;
    chartData: { [key: string]: DataForChart[] };
}) => {
    let data = chartData[measure];
    let color = colorMapping[measure];
    return [
        <VictoryLine
            key={`${measure}Line`}
            data={data}
            interpolation="monotoneX"
            style={{
                data: {
                    stroke: color,
                    strokeWidth:
                        chartWidth > widthBreakpoints.smallerScale ? 5 : 4
                }
            }}
            name={`${measure}-line`}
            labelComponent={
                <VictoryLabel
                    style={{
                        fill: colorMapping[measure],
                        ...defaultLabelStyle,
                        fontSize: getFontSize(chartWidth)
                    }}
                    dy={-5}
                    renderInPortal
                />
            }
        />,
        <VictoryScatter
            key={`${measure}Scatter`}
            style={{
                data: {
                    fill: color,
                    fillOpacity: 1,
                    stroke: ({ datum }) =>
                        datum.isArtificial ? "transparent" : color
                }
            }}
            name={`${measure}-scatter`}
            data={data.slice(1, -1).map((d) => {
                return { ...d, label: null };
            })}
            size={4}
        />
    ];
};
